import _ from 'lodash'
import type { NReports } from './Rpts.types'
import type { Form_IForm } from '../Form/Form.types'

export function Rpts_replaceImagesInReportedActions(
    reportedActions: NReports.INewIntermediateReport['reportedActionList']['reportedActions'],
    forms: Form_IForm[],
    replaceImage: (fileId: number) => string
): NReports.TSubmittedReport['reportedActionList']['reportedActions'] {
    // Get ids of image questions
    const imageQuestionIds = _(forms)
        .map((form) => form.questions)
        .flatten()
        .filter((question) => question.type === 'image' || question.type === 'signature')
        .map((question) => question.id)
        .thru((ids) => new Set<number>(ids))
        .value()

    // Remove any nulls before attempting to process. This should be done already before the function is called,
    // but some may still be sneaking through.
    const nullessReportedActions = _.compact(reportedActions)

    // Loop through the report structure and replace images with their uploaded IDs
    return nullessReportedActions.map((reportedAction) => ({
        ...reportedAction,
        reportResults: reportedAction.reportResults.map((reportResult) => {
            // Update the images for issue types
            if (reportResult.type === 'unit-issue' || reportResult.type === 'location-issue') {
                // Do all the fixes first and then loop again for the images
                const newResults = reportResult.results.map((result) => {
                    // Replace local image references with server provided online ids and
                    // filter out undefined
                    const newIssueImages = result.issue.images.map(replaceImage).filter((image) => image !== undefined)

                    // Do the same for fixes if they exist
                    const newFixImages = result.fix
                        ? result.fix.images.map(replaceImage).filter((image) => image !== undefined)
                        : []

                    // Typescript is stupid and doesn't realise that if result.fix doesn't
                    // exist then clearly the image types can't be wrong. However, it's not
                    // smart enough so we need to do this annoying hack.
                    return {
                        ...result,
                        issue: { ...result.issue, images: newIssueImages },
                        ...(result.fix && { fix: { ...result.fix, images: newFixImages } }),
                    }
                })

                return { ...reportResult, results: newResults }
            }

            if (reportResult.type === 'location-form' || reportResult.type === 'unit-form') {
                const newResults = reportResult.results.map((result) => {
                    if (!imageQuestionIds.has(result.question)) return result
                    return { ...result, answer: replaceImage(result.answer) }
                })
                return { ...reportResult, results: newResults }
            }
        }),
    }))
}
